//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getResaultProductList} from 'api/evaluation'
export default {
  props: {
    baseInfo: {
      type: [Object]
    }
  },
  data () {
    return {
      // list: [
      //   {
      //     productName: '大脑神经啊看了空间的拉萨健康拉夫黑德看了沙发经典福克斯啦荒废了大好时机咖喱和法令纹',
      //     productId: 113,
      //     state: 10001,
      //     newProductRisk: 'C4'
      //   }
      // ]
      list: []
    }
  },
  created () {
    this.getProductList()
  },
  methods: {
    orderDetail (orderId) {
      this.$bridge.callHandler('orderDetail', {message: '产品详情', orderId: orderId}, function (data) {
      })
    },
    getProductList () {
      getResaultProductList({
        plannerInvesterId: this.baseInfo.invenstemUserId,
        investerRiskLevel: this.baseInfo.result
      }, this.baseInfo.au).then((res) => {
        if (res.code === 0) {
          if (res.data.bean) {
            this.list = res.data.bean.map((item) => {
              return {
                orderId: item.orderId,
                productName: item.productName,
                state: item.state,
                newProductRisk: item.newProductRisk
              }
            })
          }
        } else {
          this.$vux.toast.show({type: 'warn', text: '获取不匹配产品异常：' + res.msg})
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/commom/tableList.vue